import axios from 'axios'
import appmock from './appmock'
import { isEnvProd } from '../base/env'
import { getLocalStorage, setLocalStorage } from '../base/storage'
import { addApi } from '../owl'
import { changeURLSearchParam } from '../base/url'
import User from '../user'

export default function (path: string, query = '', { hasTest = false, useCache = true, cacheTime = 60000 } = {}) {
  const url = appmock(
    (hasTest && !isEnvProd() ? 'https://portal-portm.sankuai' : 'https://portal-portm.meituan') + '.com' + path + query,
  )
  if (useCache) {
    const cache = getLocalStorage(url, 'Object', {})
    if (cache && cache.ts && Date.now() - cache.ts < cacheTime) {
      console.log('[portm] hit cache')
      return Promise.resolve(cache.data)
    }
  }
  return axios
    .get(
      changeURLSearchParam(url, {
        uuid: User.uuid,
      }),
    )
    .then((res) => {
      if (res.status === 200) {
        addApi({
          name: url,
          networkCode: 200,
          statusCode: 0,
        })
        if (res.data) {
          setLocalStorage(url, { data: res.data, ts: Date.now() })
          return Promise.resolve(res.data)
        }
        return Promise.resolve(undefined)
      }
      addApi({
        name: url,
        networkCode: res.status,
      })
      return Promise.reject({ status: -1, message: '请求出错' })
    })
}
